import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'pcp-theme-select',
    templateUrl: './theme-select.component.html',
    styleUrls: ['./theme-select.component.scss'],
    standalone: true
})
export class ThemeSelectComponent implements OnInit {
  constructor() {}

  @Input() theme: string | null = null;

  ngOnInit() {}
}
